import { View } from "@/components/ui";
import { useClientReviewsQuery } from "@/gqlhooks/booking/useClientReviewsQuery";
import { getReviewServiceDepartment } from "@/lib/booking-lib";
import { formatDate } from "@/lib/helpers/date";
import type { ServiceName } from "@/types/service";
import { addYears } from "date-fns";
import { CustomerReviewRating } from "./customer-review-rating";
import { ReviewCard } from "@/components/shared/review-card/review-card";
import type { ClientReviewData } from "@/types/review";
import { ReviewCardSkeleton } from "./customer-review-skeleton";

type CustomerReviewListProps = {
  serviceName: ServiceName;
  handlePreviewReview: (
    review: ClientReviewData & { imageIndex: number },
  ) => void;
};

export const CustomerReviewList = ({
  serviceName,
  handlePreviewReview,
}: CustomerReviewListProps) => {
  const { list, total, averageRating, loading } = useClientReviewsQuery({
    startDate: formatDate(addYears(new Date(), -1)),
    endDate: formatDate(new Date()),
    ...getReviewServiceDepartment(serviceName),
    limit: 30,
  });

  if (loading) {
    return (
      <View className="flex flex-col gap-3">
        <ReviewCardSkeleton />
        <ReviewCardSkeleton />
        <ReviewCardSkeleton />
      </View>
    );
  }

  return (
    <View className="flex flex-col gap-3">
      <CustomerReviewRating averageRating={averageRating} total={total} />
      {list.map((review) => (
        <ReviewCard
          key={review.id}
          clientName={review.clientName}
          ltv={review.ltv}
          rating={review.rating}
          date={review.date}
          service={review.service}
          description={review.description}
          images={review.images}
          onClick={(imageIndex) => {
            handlePreviewReview({ ...review, imageIndex });
          }}
        />
      ))}
    </View>
  );
};
